import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MonthTimetable from "../components/home/MonthTimetable";
import { fetchScreenData } from "../services/api";
import { ScreenData } from "../types/ScreenTypes";

// A masjid's monthly timetable on its own page (/month?masjidId=…), for previews until the
// Home app opens it from its bottom bar.
const MonthPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const masjidId = Number(searchParams.get("masjidId"));
  const [screen, setScreen] = useState<ScreenData | null>(null);

  useEffect(() => {
    if (masjidId) fetchScreenData(masjidId, "home").then(setScreen).catch(() => setScreen(null));
  }, [masjidId]);

  if (!screen) return null;

  return (
    <MonthTimetable
      masjidId={masjidId}
      masjidName={screen.masjidName || ""}
      masjidColor={screen.masjidColor}
      timeZone={screen.timeZone}
      use12HourFormat={screen.use12HourFormat}
      prayerNames={screen.customizedNames}
    />
  );
};

export default MonthPage;
